import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import SectionGuard from 'utils/route-guard/SectionGuard';
import environment from 'environment';
// sample page routing
const AnalysisHub = Loadable(lazy(() => import('views/pages/AnalysisHub')));
const Home = Loadable(lazy(() => import('views/pages/home')));
const Orders = Loadable(lazy(() => import('views/pages/Orders')));
const Downloads = Loadable(lazy(() => import('views/pages/Downloads')));
const Rules = Loadable(lazy(() => import('views/pages/Rules')));
const EconomicCalendar = Loadable(lazy(() => import('views/pages/EconomiCalendar')));
const Profile = Loadable(lazy(() => import('views/pages/Profile')));
const Dashboard = Loadable(lazy(() => import('views/pages/Dashboard')));
const Leaderboard = Loadable(lazy(() => import('views/pages/Leaderboard')));
const Competition = Loadable(lazy(() => import('views/pages/Competition')));
const NewEra = Loadable(lazy(() => import('views/pages/Competition/NewEra')));
const WithdrawalsSection = Loadable(lazy(() => import('views/pages/Withdrawals')));
const WithdrawalsOverview = Loadable(lazy(() => import('views/pages/Withdrawals/Overview/index')));
const Accounts = Loadable(lazy(() => import('views/pages/Withdrawals/Funds/CryptoAndOtherAccounts')));
const AccountsForm = Loadable(lazy(() => import('views/pages/Withdrawals/Funds/CryptoAndOtherAccounts/form')));
const Challenges = Loadable(lazy(() => import('views/Challenges')));
const KYCSection = Loadable(lazy(() => import('views/pages/KYC')));
const Certificates = Loadable(lazy(() => import('views/pages/Certificates')));
let MaintenanceError = Loadable(lazy(() => import('views/pages/maintenance/Error')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <SectionGuard>
                <MainLayout />
            </SectionGuard>
        </AuthGuard>
    ),
    children: [
        {
            path: '/analysis-hub',
            element: <AnalysisHub />
        },
        {
            path: '/home',
            element: <Home />
        },
        {
            path: '/orders',
            element: <Orders />
        },
        {
            path: '/calendar',
            element: <EconomicCalendar />
        },
        {
            path: '/downloads',
            element: <Downloads />
        },
        {
            path: '/rules',
            element: <Rules />
        },
        {
            path: '/profile',
            element: <Profile />
        },
        {
            path: '/dashboard',
            element: <Dashboard />
        },
        {
            path: '/leaderboard',
            element: <Leaderboard />
        },
        {
            path: '/competitions',
            element: <Competition />
        },
        {
            path: '/competitions/new-era',
            element: <NewEra />
        },
        {
            path: '/withdrawals',
            element: <WithdrawalsSection />,
            children: [
                {
                    path: 'overview',
                    element: <WithdrawalsOverview />
                },
                {
                    path: 'accounts',
                    element: <Accounts />,
                    children: [
                        {
                            path: 'add',
                            element: <AccountsForm />
                        },
                        {
                            path: ':id',
                            element: <AccountsForm />
                        }
                    ]
                }
            ]
        },
        {
            path: '/kyc',
            element: <KYCSection />
        },
        {
            path: '/challenges',
            element: <Challenges />
        },
        {
            path: '/certificates',
            element: <Certificates />
        },
        {
            path: '*',
            element: <MaintenanceError />
        }
    ].filter((r) => {
        if (!environment.FEATURES?.RULES_SECTION && r.path === '/rules') {
            return false;
        }
        if (!environment.FEATURES?.CHALLENGES_SECTION && r.path === '/challenges') {
            return false;
        }
        return true;
    })
};
export default MainRoutes;
